import BpkSmallChildIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/adult';
import BpkSmallBabyCarriageIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/baby-carriage';
import BpkSmallCityIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/city';
import BpkSmallFoodIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/food';
import BpkSmallHotelIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/hotels';
import BpkSmallPetIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/hotels--pets-allowed';
import BpkSmallInformationIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/information--language-alert';
import BpkSmallPaymentCardIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/payment-card';

import ChildIcon from './iconComponents/ChildIcon';
import CityIcon from './iconComponents/CityIcon';
import FoodIcon from './iconComponents/FoodIcon';
import HotelIcon from './iconComponents/HotelIcon';
import InformationIcon from './iconComponents/InformationIcon';
import PaymentCardIcon from './iconComponents/PaymentCardIcon';
import PetIcon from './iconComponents/PetIcon';
import {
  alipayIcon,
  amexIcon,
  dinersClubIcon,
  discoverIcon,
  eloIcon,
  hipercardIcon,
  jcbIcon,
  maestroIcon,
  masterCardIcon,
  mirIcon,
  unionPayIcon,
  visaIcon,
  wechatpayIcon,
} from './img/index';

import type { ObjectMappingEnhance } from '../types';
import type { ObjectMapping } from '@shared/types/utils';

export const paymentCard: ObjectMapping = {
  'Master Card': masterCardIcon,
  'Visa Card': visaIcon,
  'American Express Card': amexIcon,
  'Diners Card': dinersClubIcon,
  'JCB Card': jcbIcon,
  'China UnionPay Card': unionPayIcon,
  Discover: discoverIcon,
  Alipay: alipayIcon,
  Wechatpay: wechatpayIcon,
  'Mir card': mirIcon,
  Hipercard: hipercardIcon,
  'Elo Creditcard': eloIcon,
  Maestro: maestroIcon,
};

export const BED_POLICY_MAP: ObjectMapping = {
  HOTEL_POLICY_TYPE_AVAILABLE_BED: 'HOTEL_POLICY_TYPE_AVAILABLE_BED',
  HOTEL_POLICY_TYPE_EXTRA_BED: 'HOTEL_POLICY_TYPE_EXTRA_BED',
  HOTEL_POLICY_TYPE_COT: 'HOTEL_POLICY_TYPE_COT',
};

export const IMPORTANT_NOTICE_POLICY: ObjectMapping = {
  HOTEL_POLICY_TYPE_IMPORTANT_NOTICE_FROM_HOTEL:
    'HOTEL_POLICY_TYPE_IMPORTANT_NOTICE_FROM_HOTEL',
  HOTEL_POLICY_TYPE_IMPORTANT_NOTICE_ABOUT_CITY:
    'HOTEL_POLICY_TYPE_IMPORTANT_NOTICE_ABOUT_CITY',
  HOTEL_POLICY_TYPE_TRANSFER: 'HOTEL_POLICY_TYPE_TRANSFER',
};

export const POLICY_UBFF_MAP: ObjectMapping = {
  HOTEL_POLICY_TYPE_CHILDREN: 'HOTEL_POLICY_TYPE_CHILDREN',
  ...BED_POLICY_MAP,
  HOTEL_POLICY_TYPE_PET: 'HOTEL_POLICY_TYPE_PET',
  HOTEL_POLICY_TYPE_BREAKFAST: 'HOTEL_POLICY_TYPE_BREAKFAST',
  ...IMPORTANT_NOTICE_POLICY,
  HOTEL_POLICY_TYPE_PAYMENT_METHOD: 'HOTEL_POLICY_TYPE_PAYMENT_METHOD',
};

export const POLICY_ICON_DESKTOP: ObjectMappingEnhance = {
  Children: <ChildIcon />,
  AdditionalBeds: <HotelIcon />,
  AvailableBeds: <HotelIcon />,
  Pets: <PetIcon />,
  Breakfast: <FoodIcon />,
  ImportantNoticeFromTheHotel: <InformationIcon />,
  ImportantNoticeAboutTheCity: <CityIcon />,
  PaymentMethod: <PaymentCardIcon />,
  Transfer: null,
};

export const POLICY_ICON_MOBILE: ObjectMappingEnhance = {
  Children: <BpkSmallChildIcon />,
  AdditionalBeds: <BpkSmallHotelIcon />,
  AvailableBeds: <BpkSmallHotelIcon />,
  Pets: <BpkSmallPetIcon />,
  Breakfast: <BpkSmallFoodIcon />,
  ImportantNoticeFromTheHotel: <BpkSmallInformationIcon />,
  ImportantNoticeAboutTheCity: <BpkSmallCityIcon />,
  PaymentMethod: <BpkSmallPaymentCardIcon />,
  Transfer: null,
};

export const POLICY_UBFF_ICON_MOBILE: ObjectMappingEnhance = {
  HOTEL_POLICY_TYPE_CHILDREN: <BpkSmallChildIcon />,
  HOTEL_POLICY_TYPE_AVAILABLE_BED: <BpkSmallHotelIcon />,
  HOTEL_POLICY_TYPE_EXTRA_BED: <BpkSmallHotelIcon />,
  HOTEL_POLICY_TYPE_COT: <BpkSmallBabyCarriageIcon />,
  HOTEL_POLICY_TYPE_PET: <BpkSmallPetIcon />,
  HOTEL_POLICY_TYPE_BREAKFAST: <BpkSmallFoodIcon />,
  HOTEL_POLICY_TYPE_IMPORTANT_NOTICE_FROM_HOTEL: <BpkSmallInformationIcon />,
  HOTEL_POLICY_TYPE_IMPORTANT_NOTICE_ABOUT_CITY: <BpkSmallCityIcon />,
  HOTEL_POLICY_TYPE_PAYMENT_METHOD: <BpkSmallPaymentCardIcon />,
};
